<template>
  <div
    id="card-item-container"
    class="border-bottom align-middle card-row row cursor-pointer mr-0"
    @click="checkout()"
  >
    <div class="d-inline col-10 pr-0">
      <div class="d-table-cell">
        <img
          :src="cardItem.digitalCardData.artUri"
          alt="No Image"
          class="img-style"
        >
      </div>
      <div
        id="card-name"
        class="text-capitalize pt-2 pl-1 d-inline d-table-cell"
      >
        {{ cardItem.digitalCardData.descriptorName || cardItem.paymentCardDescriptor || cardItemNetwork }}
        **** **** **** {{ cardItem.panLastFour }}
      </div>
      <div
        v-if="cardBenefitText"
        class="text-wrap mt-3 cardBenefit"
        v-html="cardBenefitText"
      />
    </div>
    <div class="col-2 d-inline text-right pt-2">
      <span class="fa fa-angle-right"/>
    </div>
  </div>
</template>

<script>

import utils from '../../../../utils/utils'
import checkout from '../../../../utils/checkout'
import sharedService from '../../../../utils/shared-service'
import { CONSTANT, DEFAULT_CHECKOUT_EXPERIENCE, windowRefTypes } from '../../../../utils/constant'
import { mapGetters } from 'vuex'
import { EventBus } from '../../../../event-bus'

export default {
  name: 'CardItem',
  props: {
    cardItem: {
      type: Object,
      default: function () {
        return {
          digitalCardData: {
            artUri: 'blank.png'
          }
        }
      }
    }
  },

  data () {
    return {
      cardItemNetwork: '',
      cardBenefitText: ''

    }
  },

  computed: {
    ...mapGetters(['checkoutProgress', 'selectedCheckoutExperience', 'payloadRequested', 'authPreference', 'isConsumerAuthModuleEnable', 'windowRefType'])
  },

  created () {
    this.cardItemNetwork = ((this.cardItem || {}).network || '').replace(/-/g, ' ').toLowerCase()
    let digitalCardFeatures = ((this.cardItem || {}).digitalCardFeatures || [])
    this.cardBenefitText = ((digitalCardFeatures[0] || {}).content || '')
  },

  methods: {

    /**
     * This method is use to invoke popup experince.
     */
    invokePopup () {
      utils.loaderTimeOut(8000)
      this.$store.dispatch('lightBoxloaderOn', true)
      if (!window.opener) {
        sharedService.invokeSrc(false, CONSTANT.SRC.INLINE_CARD, this.$store)
      }
    },

    /**
     * This method is use to set window Reference (popup,actionsheet/iframe)for DCF.
     */
    setWindowReference () {
      if (this.isConsumerAuthModuleEnable && this.windowRefType === windowRefTypes.ACTION_SHEET) {
        this.$store.dispatch('lightBoxloaderOn', true)
        this.$parent.$parent.$refs.authenticationIframe.addEventListener('load', () => {
          this.$store.dispatch('lightBoxloaderOn', false)
          EventBus.$emit('visibleActionsheet', false)
        })
        window.checkoutIframeRef = this.getIframeRefForActionsheet()
      } else {
        this.$store.dispatch('lightBoxloaderOn', true)
        let isIframe = true
        const isDefaultExperiance = this.selectedCheckoutExperience !== DEFAULT_CHECKOUT_EXPERIENCE
        const isiFramePFL = this.isConsumerAuthModuleEnable && this.windowRefType === windowRefTypes.IFRAME
        if (this.authPreference && this.cardItemNetwork === 'mastercard' && sharedService.checkFeatureFlag('START_LMC_CHANGES')) {
          isIframe = !(this.payloadRequested === 'AUTHENTICATED')
        }
        if ((isiFramePFL || isDefaultExperiance) && isIframe) {
          this.$parent.$refs.iframe.addEventListener('load', () => {
            this.$store.dispatch('lightBoxloaderOn', false)
            this.$store.commit('checkoutProgress', true)
            this.$parent.$refs.iframeContainer.classList.add('show')
          }, { once: true })
          this.$parent.$refs.iframeBackground.addEventListener('click', () => {
            this.$parent.$refs.iframeContainer.classList.remove('show')
            this.$store.commit('checkoutProgress', false)
          })
          window.checkoutIframeRef = this.getIframeRef()
        } else {
          this.invokePopup()
        }
      }
    },

    /**
     * This method calls checkout api on card selection
     */
    checkout () {
      try {
        this.setWindowReference()
        let windowRef = !window.opener ? checkout : window.opener.checkout
        windowRef.initiate({
          cardDetail: this.cardItem,
          enrollCard: false
        })
      } catch (e) {
        console.log('Exception in checkout', e)
      }
    },

    getIframeRef () {
      if (this.cardItemNetwork === 'visa') {
        return this.$parent.$refs.iframe
      } else {
        return this.$parent.$refs.iframe.contentWindow
      }
    },

    getIframeRefForActionsheet () {
      if (this.cardItemNetwork === 'visa') {
        return this.$parent.$parent.$refs.iframe
      } else {
        return this.$parent.$parent.$refs.authenticationIframe.contentWindow
      }
    }

  }
}
</script>

<style scoped>
@import "card-item.scss";
</style>
